import type { FunctionComponent } from 'react';
import { AbsValue, TotalValue, NAValue, Cell } from './styled';

interface Props {
  toggled?: boolean;
  totalValue?: string | number | null;
  absValue?: string | number | null;
}

const ToggleCell: FunctionComponent<Props> = ({
  toggled,
  totalValue,
  absValue,
}) => {
  const bothNA = totalValue === 'n/a' && absValue === 'n/a';

  return (
    <Cell>
      {bothNA ? (
        <NAValue toggled={toggled}>{absValue}</NAValue>
      ) : (
        <>
          <TotalValue toggled={toggled}>
            {totalValue === 'n/a' ? absValue : totalValue}
          </TotalValue>
          <AbsValue toggled={toggled}>{absValue}</AbsValue>
        </>
      )}
    </Cell>
  );
};

export { ToggleCell };
